module.exports = __webpack_public_path__ + "images/szvk4e07e6c54efadea4309b5f69ae44c433.png";